import logo from '../logo.svg';
import '../App.css';
import { NavLink } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addItem, removeItem, clearAllItems } from '../slice/slice';
import { useNavigate } from "react-router-dom"
import { MessageContext } from "../context/MessageContext";
function CartList() {

  const cartSelector = useSelector((state) => state.cart.items);
  const [cartItems, setCartItems] = useState(cartSelector)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { showMessage } = useContext(MessageContext);
  useEffect(() => {
    setCartItems(cartSelector)
  }, [cartSelector])

  const userData = localStorage.getItem("user") ?? null;
  const token = localStorage.getItem("token");

  const manageQuantity = (id, q) => {
    let quantity = parseInt(q) > 1 ? parseInt(q) : 1

    const cartTempItems = cartItems.map((item) => {
      return item.id == id ?
        { ...item, quantity } : item
    })
    setCartItems(cartTempItems)
  }

  const handlePlaceOrder = async () => {
    if (cartItems.length > 0) {
      if (!userData) {
        showMessage("Please Do Login to place order", "danger");
        navigate("/login")
        return;
      }

      const filteredItems = cartItems.map(item => ({
        medicine_id: item._id,
        quantity: item.quantity ? item.quantity : 1
      }));

      const API_URL = process.env.REACT_APP_API_URL;

      // for (let item of filteredItems) {
      //   const res = await fetch(`${API_URL}/medicines/${item.id}`);
      //   const medicine = await res.json();
      //   const updatedStock = medicine.stock - item.quantity;
      //   await fetch(`${API_URL}/medicines/${item.id}`, {
      //     method: "PUT",
      //     body: JSON.stringify({ ...medicine, stock: updatedStock }),
      //     headers: {
      //       "Content-Type": "application/json"
      //     }
      //   });
      // }

    let response = await fetch(`${API_URL}/booking`,{
        method: "POST",
        headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
        body: JSON.stringify({
          items: filteredItems
        })
      });
      response = await response.json();
      dispatch(clearAllItems())
      localStorage.removeItem("cart")
      showMessage("Order Placed Successfully", "success");
    }
    navigate("/thank-you")
  }
  return (
    <>
      <Helmet>
        <title>Cart List | Clinic</title>
        <meta name="description" content="Our medicine department" />
        <meta name="keywords" content="medicine, pharmacy, clinic" />
      </Helmet>
      <div className="page-title">

      </div>

      <section className="container">
        <div className="card shadow-sm border-0">
          <div className="card-body">

            <div className="d-flex justify-content-between align-items-center mb-4">
              <h4 className="mb-0 fw-semibold">Your Cart Items</h4>
              <span className="badge bg-primary fs-6">
                {cartItems.length} items
              </span>
            </div>

            {cartItems.length > 0 ? (
              cartItems.map((item) => (
                <div key={item.id} className="row align-items-center border-bottom py-3">

                  <div className="col-md-6 d-flex align-items-center">
                    <img
                      src="assets/img/capsule.jpg"
                      alt=""
                      className="img-fluid rounded"
                      style={{ width: "80px", height: "80px", objectFit: "cover" }}
                    />
                    <div className="ms-3">
                      <h6 className="mb-1 fw-bold">{item.title}</h6>
                      <small className="text-muted">{item.brand}</small>
                    </div>
                  </div>

                  <div className="col-md-3 mt-3 mt-md-0">
                    <div className="row align-items-center">

                      <div className="col-6">
                        <input
                          onChange={(e) => manageQuantity(item.id, e.target.value)}
                          value={item.quantity ? item.quantity : 1}
                          className="form-control form-control-sm"
                          type="number"
                          min="1"
                        />
                      </div>

                      <div className="col-6 text-end">
                        <span className="fw-semibold text-primary">
                          $
                          {(item.quantity
                            ? item.price * item.quantity
                            : item.price
                          ).toFixed(2)}
                        </span>
                      </div>

                    </div>
                  </div>


                  <div className="col-md-3 text-md-end mt-3 mt-md-0">
                    <button
                      onClick={() => dispatch(removeItem(item))}
                      className="btn btn-outline-danger btn-sm"
                    >
                      Remove
                    </button>
                  </div>

                </div>
              ))
            ) : (
              <div className="text-center py-5">
                <h6 className="text-muted">🛒 Your cart is empty</h6>
              </div>
            )}

            {cartItems.length > 0 && (
              <div className="d-flex justify-content-between align-items-center mt-4 pt-3 border-top">
                <h5 className="mb-0 fw-semibold">
                  Total: $
                  {cartItems
                    .reduce((sum, item) =>
                      item.quantity
                        ? sum + item.price * item.quantity
                        : sum + item.price,
                      0
                    )
                    .toFixed(2)}
                </h5>

                <button onClick={() => handlePlaceOrder()} className="btn btn-success px-4">
                  Proceed to Checkout
                </button>
              </div>
            )}

          </div>
        </div>
      </section>

    </>
  );
}

export default CartList;
